var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "aside",
    { staticClass: "spa-reservation-sidebar" },
    [
      _vm.isReservationCancelled
        ? [
            _c(
              "div",
              {
                staticClass: "spa-reservation-sidebar__section",
                class: { "--cancelled": _vm.isReservationCancelled },
              },
              [
                _c("h3", { staticClass: "spa-reservation-sidebar__title" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.tc(
                          "spaSoft.reservationdetails.cancelDetails.contactUsTitle"
                        )
                      ) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c("p", {
                  staticClass: "spa-reservation-sidebar__text",
                  class: { "--cancelled": _vm.isReservationCancelled },
                  domProps: { innerHTML: _vm._s(_vm.contactUsDescription) },
                }),
              ]
            ),
          ]
        : [
            _c(
              "picture",
              {
                directives: [
                  {
                    name: "lazyload",
                    rawName: "v-lazyload",
                    value: {
                      src:
                        "" + _vm.reservationDetailsData.propertyData.imageSrc,
                      set: [
                        { width: "720", height: "405", breakpoint: "xs" },
                        { width: "1024", height: "576", breakpoint: "md" },
                      ],
                      fit: "crop",
                      align: "center",
                    },
                    expression:
                      "{\n        src: `${reservationDetailsData.propertyData.imageSrc}`,\n        set: [\n          { width: '720', height: '405', breakpoint: 'xs' },\n          { width: '1024', height: '576', breakpoint: 'md' }\n        ],\n        fit: 'crop',\n        align: 'center',\n      }",
                  },
                ],
                staticClass: "image-wrapper spa-reservation-sidebar__image",
              },
              [
                _c("img", {
                  staticClass: "image",
                  attrs: {
                    src: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
                    alt: _vm.reservationDetailsData.propertyData.facilityName,
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "spa-reservation-sidebar__section" },
              [
                _c(
                  "div",
                  { staticClass: "spa-reservation-sidebar__section-policies" },
                  [
                    _c("div", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.reservationDetailsData.propertyData
                            .reservationDetailsPolicies
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("div", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.reservationDetailsData.propertyData
                            .cancellationDetailsPolicies
                        ),
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("spa-cancel-modal", {
                  attrs: { type: "booking" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var activate = ref.activate
                        return _c(
                          "button",
                          {
                            staticClass: "spa-reservation-sidebar__cancel-btn",
                            attrs: { type: "button" },
                            on: {
                              click: activate,
                              keydown: [
                                function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "space",
                                      32,
                                      $event.key,
                                      [" ", "Spacebar"]
                                    )
                                  ) {
                                    return null
                                  }
                                  $event.preventDefault()
                                  return activate($event)
                                },
                                function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  $event.preventDefault()
                                  return activate($event)
                                },
                              ],
                            },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.tc(
                                    "spaSoft.reservationdetails.cancelBookingCta"
                                  )
                                ) +
                                "\n        "
                            ),
                          ]
                        )
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }